import Homescreen from '../components/Landpage'

export default function Home() {
  return (
    <Homescreen/>
  )
}
